import ContentBox from 'components/ContentBox'
import React from 'react'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'

export default function ContentBoxBackgroundContent (props) {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  return (
    <ContentBox
      bgc='backgroundContent'
      bdr={isSmallScreen}
      {...props}
    />
  )
}
